<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
<path d="M21.916 16.688L14.6813 4.16C14.1227 3.19067 13.12 2.612 12 2.612C10.88 2.612 9.87733 3.19067 9.31867 4.16L2.084 16.688C1.524 17.6587 1.524 18.816 2.084 19.7853C2.644 20.7547 3.64667 21.3333 4.76533 21.3333H19.2333C20.352 21.3333 21.3547 20.7547 21.9147 19.7853C22.4747 18.816 22.476 17.6587 21.916 16.688Z"/>
</svg>
